import { useContext } from 'react';
import axios from 'axios';
import { StoreContext } from '../StoreProvider';

const useTracking = () => {
    const { settings } = useContext(StoreContext);
    const API_BASE = settings.cdn || (settings.development ? 'http://localhost:3000' : 'https://api.thevideogram.com');
    const STATISTICS_REPORT_URI = `${API_BASE}/events/videowatch/${settings.tenantId}/${settings.scenarioId}`;

    const sendEvent = (data) => {
        try {
            axios.post(STATISTICS_REPORT_URI, data);
        } catch (e) {
            console.error(e);
        }
    };

    const sendBeacon = (event, videoData, url) => {
        const data = {
            context: {
                id: settings.id,
                viewerId: settings.viewerId,
            },
            time: {
                current: new Date().toISOString(),
                zoneOffset: new Date().getTimezoneOffset(),
            },
            video: {
                event,
                ...videoData
            }
        }

        // Events always sent — accumulator handles the load

        if (!navigator.sendBeacon) {
            sendEvent(data);
            return;
        }

        const blob = new Blob([JSON.stringify(data)], {
            type: 'application/json'
        });

        navigator.sendBeacon(url ? url : STATISTICS_REPORT_URI, blob);
    };

    return {
        sendEvent,
        sendBeacon,
    }
}

export default useTracking;
